var _rect, _rect2, _circle, _circle2, _path, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobicircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 568,
    viewBox: "0 0 552 568",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 28,
    width: 489,
    height: 489,
    rx: 244.5,
    stroke: "#EEEEEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 148,
    width: 250,
    height: 250,
    rx: 125,
    fill: "white",
    stroke: "#E5E5E5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 248,
    r: 25,
    fill: "#45E071"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 299.529,
    cy: 248,
    r: 25,
    fill: "#E3FF75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.02 317L262.169 320.848L259.32 323.808L255.879 325.991L255.176 324.511L257.396 322.809L258.95 320.478L259.394 317L259.431 311.265V304.161L259.098 300.313L256.545 300.424L256.36 299.129L261.466 298.13L263.316 298.537L263.057 303.569L262.909 307.269L263.02 317ZM258.876 290.804L260.578 289.99L262.354 290.582L263.168 292.58L262.132 294.208L260.393 294.911L258.765 293.912L257.988 292.247L258.876 290.804ZM267.155 309.97V305.123L269.338 300.72L273.519 297.945L278.588 297.76L283.213 300.535L285.618 304.975L285.174 311.746L282.436 316.112L276.701 317.74L271.891 316.815L268.376 313.633L267.155 309.97ZM271.225 303.865L271.04 308.009L271.484 312.301L273.075 315.076L276.997 316.038L280.623 314.447L281.696 308.675L281.326 303.865L279.957 300.794L277.256 299.425L273.556 299.832L271.225 303.865ZM293.135 300.091L293.394 300.35L297.242 298.241L301.275 298.13L305.197 301.127L306.751 307.306L305.641 312.819L302.977 316.186L297.649 317.74L290.656 316.815L289.361 315.52L289.657 303.31L289.62 294.911L289.435 291.211L286.808 291.322L286.623 290.027L291.729 289.028L293.579 289.435L293.135 300.091ZM293.061 311.339L293.357 314.78L298.167 315.853L301.83 313.559L302.903 309.489L302.755 304.605L300.128 300.794L297.834 300.239L293.135 302.126L293.061 311.339ZM311.386 290.804L313.088 289.99L314.864 290.582L315.678 292.58L314.642 294.208L312.903 294.911L311.275 293.912L310.498 292.247L311.386 290.804ZM315.567 303.569L315.345 307.269L315.456 310.858L315.604 315.15L318.305 315.89L318.12 317.185L313.754 317L309.24 317.185L309.314 315.89L311.756 315.15L311.941 311.265L311.867 304.161L311.682 300.313L309.055 300.424L308.87 299.129L313.976 298.13L315.826 298.537L315.567 303.569Z",
    fill: "#252525"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 498.5,
    cy: 133.5,
    r: 52.5,
    fill: "white",
    stroke: "#E8E8E8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 180.5,
    r: 52.5,
    fill: "white",
    stroke: "#E8E8E8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.5,
    cy: 33.5,
    r: 32.5,
    fill: "white",
    stroke: "#E8E8E8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 435.5,
    r: 40.5,
    fill: "white",
    stroke: "#E8E8E8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 493,
    r: 74,
    fill: "white",
    stroke: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobicircle);
export default __webpack_public_path__ + "static/media/jobicircle.53a71ed0ba7f744c3a422c81dc4b5321.svg";
export { ForwardRef as ReactComponent };